export default {
  bodyFg: '#515151',
  primary: '#ff0000',
  secondary: '#00ff00',
}
